// extracted by mini-css-extract-plugin
module.exports = {"Container":"informationPopup_Container__3OcLA","Text":"informationPopup_Text__1d8vN"};